import { render, staticRenderFns } from "./BrandRecordItem.vue?vue&type=template&id=46d4102e&scoped=true&"
import script from "./BrandRecordItem.vue?vue&type=script&lang=js&"
export * from "./BrandRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./BrandRecordItem.vue?vue&type=style&index=0&id=46d4102e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4102e",
  null
  
)

export default component.exports